import { AxiosResponse } from 'axios';
import { PagedResponse } from '@types_main/paged-response';
import { PagedParams } from '@types_main/paged.params';
import { BaseService } from '../../../../../services/route.service';
import { LeadHistoryRequest } from './requests/lead-history.request';
import { LeadHistoryResponse } from './responses/lead-history.response';

export class CrmHistoryService extends BaseService {
    protected get resourceName(): string {
        return 'crm/lead-histories';
    }

    public async getAll(
        filter?: string,
        params?: PagedParams
    ): Promise<AxiosResponse<PagedResponse<LeadHistoryResponse>>> {
        return await this.get(`by-lead/${filter}`, params);
    }

    public async create(
        body: LeadHistoryRequest
    ): Promise<AxiosResponse<{ data: LeadHistoryResponse }>> {
        return await this.post(body);
    }
}
